import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './Home.css';
import WorkshopModal from './WorkshopModal';


export default function App() {
  const [locations, setLocations] = useState([]);
  const [filter, setFilter] = useState('wszystkie');
  const [filteredData, setFilteredData] = useState([]);
  const [activeWorkshop, setActiveWorkshop] = useState(null);


  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/workshops.json`)
      .then((res) => res.json())
      .then((data) => setLocations(data))
      .catch((err) => console.error('Błąd wczytywania danych:', err));
  }, []);

  useEffect(() => {
    let data = [...locations];

    switch (filter) {
      case 'rekodzielo':
      case 'sztuki-wizualne':
      case 'sztuki-wizualne-rekodzielo':
      case 'instytucje-kulturalne':
        data = data.filter((item) => item.category === filter);
        break;
      case 'accommodation':
        data = data.filter((item) => item.accommodation === true);
        break;
      case 'accessible':
        data = data.filter((item) => item.disabled === true);
        break;
      default:
        break;
    }

    setFilteredData(data);
  }, [filter, locations]);

  const visibleWorkshops = filteredData.filter(
    (item) => item.id != null
  );


  const goPrevWorkshop = (current) => {
    const index = visibleWorkshops.findIndex(
      (w) => w.id === current.id
    );

    if (index <= 0) return;

    setActiveWorkshop(visibleWorkshops[index - 1]);
  };

  const goNextWorkshop = (current) => {
    const index = visibleWorkshops.findIndex(
      (w) => w.id === current.id
    );

    if (index >= visibleWorkshops.length - 1) return;

    setActiveWorkshop(visibleWorkshops[index + 1]);
  };


  const customIcon = (url) =>
    L.icon({
      iconUrl: url,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

  const instytucjeKulturalne = filteredData.filter(
    (item) => item.category === 'instytucje-kulturalne'
  );

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  return (
    <div className='container'>

      <img className='main-title'
        src={
          isMobile
            ? process.env.PUBLIC_URL + "/img/otwarte-pracownie-2026-mobile.png"
            : process.env.PUBLIC_URL + "/img/otwarte-pracownie-2026.svg"
        }
        alt="główny tytuł"
      />

      <div className='events-container '>
        <div className='text-in-frame-main'>
          <p>
            <b>Otwarte Pracownie na Mazurach to zaproszenie do odkrywania Mazur z&nbsp;zupełnie innej perspektywy</b> — przez pryzmat sztuki, rzemiosła, pasji i&nbsp;ludzi, którzy tworzą ten region.
          </p>

          <p>Mazury to nie tylko jeziora, lasy i&nbsp;krajobrazy. To także wyjątkowi ludzie — artyści, rzemieślnicy, rękodzielnicy i&nbsp;twórcy, którzy żyją i&nbsp;pracują blisko natury, tworząc w&nbsp;miejscach pełnych autentyczności, spokoju i&nbsp;inspiracji.</p>

          <p>Przez dwa dni w&nbsp;roku — <b>11 i&nbsp;12 lipca 2026</b> — drzwi do tych niezwykłych miejsc otwierają się szeroko.</p>

          <p>Zapraszamy do odwiedzania prywatnych pracowni, domowych galerii i&nbsp;przestrzeni twórczych rozsianych po całych Mazurach. To wyjątkowa okazja, by zajrzeć tam, gdzie na co dzień powstają obrazy, ceramika, rzeźby, grafiki, tkaniny, biżuteria i&nbsp;rękodzieło.</p>

          <p>Podczas wizyt możesz nie tylko oglądać gotowe prace, ale także spotkać twórców osobiście — porozmawiać, poznać ich historie, zobaczyć proces twórczy z&nbsp;bliska i&nbsp;odkryć, jak powstaje sztuka zakorzeniona w&nbsp;mazurskim krajobrazie.</p>

          <p>To wydarzenie dla wszystkich — mieszkańców, turystów, rodzin z&nbsp;dziećmi, miłośników sztuki i&nbsp;osób poszukujących autentycznych doświadczeń.</p>

          <p>Na interaktywnej mapie znajdziesz lokalizacje wszystkich pracowni biorących udział w&nbsp;tegorocznej edycji, a&nbsp;także dokładne dane kontaktowe, opisy twórców oraz zdjęcia, które pozwolą poczuć klimat każdego miejsca.</p>

          <p>Oczywiście odwiedzenie wszystkich pracowni w&nbsp;jeden weekend jest niemal niemożliwe — i&nbsp;właśnie w&nbsp;tym tkwi piękno tego projektu. Każda trasa może stać się osobną podróżą przez sztukę, naturę i&nbsp;niezwykłe spotkania.</p>

          <p>Warto pamiętać, że wielu twórców zaprasza gości także poza terminem wydarzenia. Wystarczy zadzwonić, napisać i&nbsp;umówić się na indywidualną wizytę. W&nbsp;wielu pracowniach można nie tylko kupić wyjątkowe prace, ale również wziąć udział w&nbsp;warsztatach, a&nbsp;niektóre miejsca oferują także noclegi.</p>
        </div>

        <div className='text-in-frame-main'>
          <p><b>Otwarte Pracownie na Mazurach to coś więcej niż wydarzenie.</b></p>

          <p>To spotkanie.</p>

          <p>To relacje.</p>

          <p>To wspólnota ludzi, którzy wierzą, że kultura i&nbsp;sztuka mają moc budowania więzi oraz wzmacniania lokalnej tożsamości.</p>

          <p>Jeśli jesteś osobą twórczą i&nbsp;chcesz dołączyć do Otwartych Pracowni na Mazurach w&nbsp;kolejnych edycjach lub masz pomysł na współpracę — napisz do&nbsp;nas: <a href="mailto:forumartystyczne@gmail.com"><b>forumartystyczne@gmail.com</b></a></p>

          <p>Możesz także wesprzeć rozwój projektu i&nbsp;nasze bezpłatne działania, przekazując darowiznę na cele statutowe Stowarzyszenia <b>Nasze Talki</b>. Każde wsparcie pomaga nam kontynuować pracę na rzecz mazurskiej kultury — autentycznej, niezależnej i&nbsp;dostępnej dla wszystkich.</p>

          <p>Dane Stowarzyszenia oraz informacje dotyczące wsparcia znajdziesz pod numerem 1 na mapie.</p>

          <p>Dziękujemy, że jesteś z&nbsp;nami.</p>
          <p> Do zobaczenia na Mazurach — i&nbsp;do zobaczenia w&nbsp;pracowniach.</p>
        </div>
      </div>


      <div className='map-container'>
        <div className='stripe'>
          <h2 className='subheadline-black'>
            52 pracownie<br /> artystyczne i rękodzielnicze!
          </h2>
        </div>

        <div className='legend'>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-artystyczne.svg`}
              alt='artystyczne'
              className='workshop-marker-mini'
            />
            <span>pracownie artystyczne</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-rekodzielnicze.svg`}
              alt='rekodzielnicze'
              className='workshop-marker-mini'
            />
            <span>pracownie rękodzielnicze</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-rekodzielniczo-artystyczne.svg`}
              alt='rekodzielniczo-artystyczne'
              className='workshop-marker-mini'
            />
            <span>pracownie rękodzielniczo-artystyczne</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-instytucje-kulturalne-legend.svg`}
              alt='instytucje kulturalne'
              className='workshop-marker-mini'
            />
            <span>instytucje i placówki kulturalne</span>
          </div>
        </div>

        <MapContainer
          center={[54.03416228438315, 21.768465455440772]}
          zoom={9}
          className='map'
        >
          <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />




          {filteredData
            .filter(
              (item) =>
                item.category !== 'instytucje-kulturalne' ||
                filter === 'wszystkie' ||
                filter === 'instytucje-kulturalne'
            )
            .map((item) => (
              <Marker
                key={item.id}
                position={item.position}
                zIndexOffset={[1, 3, 9, 15, 18, 36, 44].includes(item.id) ? 1000 : 0}
                eventHandlers={{
                  add: (e) => {
                    if (item.id === 1) {
                      setTimeout(() => e.target.bringToFront(), 0);
                    }
                  }
                }}
                icon={customIcon(process.env.PUBLIC_URL + '/' + item.marker)}
              >
                <Popup>
                  <div className='popup-container'>
                    {item.imageSmall && (
                      <img
                        src={`${process.env.PUBLIC_URL}/${item.imageSmall}`}
                        alt={item.name}
                        className='workshop-img-mini'
                      />
                    )}



                    <div className='popup-container-text'>
                      <b>{item.name}</b>
                      <p>
                        {[4, 10, 19, 37, 45].includes(item.id)
                          ? "ADRES (GOŚCINNIE):"
                          : "ADRES:"}
                        <br />
                        <span
                          dangerouslySetInnerHTML={{ __html: item.adress }}
                        />
                      </p>
                      {/*   {item.info &&
                        item.category === 'instytucje-kulturalne' && (
                          <p>
                            WYDARZENIA:
                            <br />
                            <span
                              className='popup-events-list'
                              dangerouslySetInnerHTML={{ __html: item.info }}
                            />
                          </p>
                        )} */}
                      {item.hours && (
                        <div className='popup-line'>
                          <img
                            src={`${process.env.PUBLIC_URL}/img/zegar.svg`}
                            alt='ikona zegara'
                            className='icon-small'
                          />
                          <span
                            dangerouslySetInnerHTML={{ __html: item.hours }}
                          />
                        </div>
                      )}
                      <div className='popup-line-icons'>
                        {item.disabled && (
                          <img
                            src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                            alt='Udogodnienia dla niepełnosprawnych'
                            className='icon-small'
                          />
                        )}
                        {item.accommodation && (
                          <img
                            src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                            alt='Nocleg'
                            className='icon-small-horizontal'
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {item.category !== 'instytucje-kulturalne' && (
                    <a
                      key={item.id}
                      className='popup-link'
                      onClick={() => setActiveWorkshop(item)}
                    >
                      Więcej informacji
                    </a>
                  )}
                </Popup>
              </Marker>
            ))}
        </MapContainer>
      </div>

      <div className='options-container'>
        <div className='option-filter-container'>
          <span className='options-text'>Pokaż:</span>
          <select
            onChange={(e) => setFilter(e.target.value)}
            className='options-filter'
          >
            <option value='wszystkie'>wszystkie miejsca</option>
            <option value='rekodzielo'>pracownie rękodzielnicze</option>
            <option value='sztuki-wizualne'>pracownie artystyczne</option>
            <option value='sztuki-wizualne-rekodzielo'>
              pracownie rękodzielniczo-artystyczne
            </option>
            <option value='instytucje-kulturalne'>instytucje i placówki kulturalne</option>
            <option value='accommodation'>możliwość noclegu</option>
            <option value='accessible'>
              miejsca przystosowane dla osób z niepełnosprawnością
            </option>
          </select>
        </div>
      </div>

      <div className='workshops-container'>
        {visibleWorkshops.map((item) => (
          <div
            key={item.id}
            className='workshop'
            onClick={() => setActiveWorkshop(item)}
          >
            <div
              className={'workshop-img-wrapper'}
            >
              <img
                src={`${process.env.PUBLIC_URL}/${item.image}`}
                alt={item.name}
                className='workshop-img'
              />
              <div className='workshop-marker-wrapper'>
                <img
                  src={`${process.env.PUBLIC_URL}/img/znaczniki/blank-under-marker.svg`}
                  alt='znacznik-tło'
                  className='workshop-marker-bg'
                />
                <img
                  src={`${process.env.PUBLIC_URL}/${item.marker}`}
                  alt='znacznik'
                  className='workshop-marker'
                />
              </div>
            </div>

            <h6 className='text-specialization'>{item.specialization}</h6>
            <h3 className='text-name'>{item.name}</h3>
          </div>
        )
        )}

        {activeWorkshop && (
          <WorkshopModal
            workshop={activeWorkshop}
            workshops={visibleWorkshops}
            onWorkshopChange={setActiveWorkshop}
            onNext={goNextWorkshop}
            onPrev={goPrevWorkshop}
            onClose={() => setActiveWorkshop(null)}
          />
        )}
      </div>

      <div className='events-container'>

        <div className='text-in-frame events-exception'>
          <h2 className='subheadline-uppercase'>Imprezy towarzyszące:</h2></div>

        <div className='text-in-frame events-exception'>
          <p>
            <span className='bold-text'>
              Ogródek Sztuki - Interdyscyplinarna<br />
              Wystawa Mazurskich Artystów
            </span><br />
            <span className='cursive-text'>1 sierpnia – 16.00-19.00<br />
              / Muzeum Michała Kajki w Ogródku</span>

          </p></div>

        <div className='text-in-frame events-exception'>
          <span className='bold-text'>XXXV Wydmiński Jarmark<br />Twórców Ludowych</span><br />
          <span className='cursive-text'>14 sierpnia – 16.00-20.00</span><br />
          <span className='bold-text'>— Dzień Otwartych Pracowni</span><br />
          <span className='cursive-text'>15 sierpnia – 14.00-20.00</span><br />
          <span className='bold-text'>— Jarmark sztuki i rękodzieła</span><br />
          <span className='cursive-text'>/ Plac Targowy, Wydminy</span>
        </div>


        <div className='text-in-frame events-exception'>
          <span className='bold-text'>Targi Sztuki i Rękodzieła</span><br />
          <span className='cursive-text'>14-16 sierpnia – 10.00-18.00<br />/ Memuak, Sztynort</span>
        </div>
      </div>

      <div className='logo-section'>
        <div className='logo-section-smaller'>
          <div className='logo-section-little'>
            <p>Organizator:</p>
            <img
              className='logo-section-img-horizontal'
              src={`${process.env.PUBLIC_URL}/img/logo/logo-nasze-talki.svg`}
              alt='Logo stowarzyszenia Nasze Talki'
            />
          </div>



          <div className='logo-section-few'>
            <p>Partnerzy:</p>
            <div className='logo-section-mini-container'>

              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/gmina-wydminy.png`}
                alt='Współfinansowanie'
              />

              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/zaiks-logo.svg`}
                alt='Współfinansowanie'
              />

              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-galeria-ita-hareza.svg`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-memuak.png`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-mk-ogrodek.png`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-wydminy.svg`}
                alt='Współfinansowanie'
              />
            </div>
          </div>


        </div>
      </div>
    </div >
  );
}
